import React from "react";

const CustomButton = ({
  variant = "create",
  children,
  onClick,
  style = {}, // Add a style prop for merging styles
  disabled,
  className,
  ...attributes
}) => {
  const buttonStyles = {
    cancel: "rounded-md items-center justify-center text-black px-4 py-2 hover:text-[#FF5B5B]",
    create:
      "rounded-md bg-secondaryColor text-white items-center justify-center px-4 py-2 hover:bg-secondaryColor hover:shadow-md",
    outline: "rounded-md flex justify-center items-center px-4 py-2",
    border:
      "rounded-md flex justify-center items-center gap-x-2 px-4 py-2 border hover:bg-gray-100 transition focus:outline-none",
    danger:
      "rounded-md bg-red-700 text-white items-center justify-center px-4 py-2 hover:bg-red-800 hover:shadow-md",
    activeBorder:
      "rounded-md flex justify-center items-center gap-x-2 px-4 py-2 border border-green-700 text-green-800 bg-green-600/10 hover:bg-green-700/10 transition focus:outline-none",
    ghost:
      "rounded-md flex justify-center items-center gap-x-2 px-4 py-2 border border-white/30 bg-white/10 hover:bg-white/20 transition focus:outline-none",
  };

  return (
    <button
      type="button"
      className={`${buttonStyles[variant]} ${className ?? ""}`}
      onClick={onClick}
      disabled={disabled} // Apply disabled prop
      style={{
        ...style, // Merge passed-in styles
        opacity: disabled ? 0.6 : 1, // Optionally dim button when disabled
      }}
      {...attributes}
    >
      {children}
    </button>
  );
};

export default CustomButton;
